/**
 * @file useLocalStorage.ts
 *
 * @fileoverview Appends DOM work to the window object for testing purposes.
 */

import { useEffect } from 'react';

export const useTestingLogger = () => {
  const testing = process.env.testing;

  useEffect(() => {
    if (testing) {
      let updatesOccur = false;
      // Create an observer instance linked to the callback function
      var observer = new MutationObserver(() => {
        if (!updatesOccur) {
          // Already running updates. Dont continue.
          updatesOccur = true;
          window['__jq_updatesOccur'] = true;
          mutationsCompletedCallback();
        }
      });
      // Start observing the target node for configured mutations
      observer.observe(window.document, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true,
      });

      let mutationsCompletedCallback = () => {
        if (updatesOccur) {
          updatesOccur = false;
          setTimeout(mutationsCompletedCallback, 300);
        } else {
          window['__jq_updatesOccur'] = false;
        }
      };
    }

    return () => {
      if (testing) {
        observer.disconnect();
      }
    };
  }, []);
};
